// extracted by mini-css-extract-plugin
export default {"stars":"style_stars__rmIzC","animStar":"style_animStar__46PKi","stars2":"style_stars2__98sGP","stars3":"style_stars3__PgZmv"};